if (document.readyState === "loading") {
    // Calls the function during the 'DOMContentLoaded' event, after the HTML document has been completely loaded
    document.addEventListener("DOMContentLoaded", function () {
        initializeSnowReports();
    });
} else {
    // Calls the function directly in cases where the widget is rendered dynamically after 'DOMContentLoaded' has occurred
    initializeSnowReports();
}


function initializeSnowReports() {
    var snowReports = $('.js-snow-report');
    snowReports.each(function () {
        var $this = $(this);
        var radioButtons = $this.find('input:radio');
        var checkedValue = $this.find("input:radio:checked").val();
        var newSnow = $this.find('.NewSnow48');
        var baseSnow = $this.find('.SnowBase');
        if (checkedValue === "new") {
            newSnow.show();
            baseSnow.hide();
        }
        if (checkedValue === "base") {
            newSnow.hide();
            baseSnow.show();
        }
        radioButtons.on('change', function () {
            var checked = $this.find("input:radio:checked").val();
            if (checked === "new") {
                newSnow.show();
                baseSnow.hide();
            }
            if (checked === "base") {
                newSnow.hide();
                baseSnow.show();
            }
        });
    });
}